import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { StockItemCategoryModelDto } from './stock-item-category-model';
export class StockItemCategoryResponseModel extends GlobalResponseObject{
    data?: StockItemCategoryModelDto[];

    constructor(status: boolean, intlCode: number, internalMessage: string, data?: StockItemCategoryModelDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
}
}
